import React, { useState, useEffect } from 'react';
import { cloudAPI } from '../../utils/api';

export default function AlertsPage() {
    const [alerts, setAlerts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cloudAPI.getAlerts()
            .then(res => {
                const d = res.data;
                const rows = Array.isArray(d) ? d
                           : Array.isArray(d?.alerts) ? d.alerts
                           : Array.isArray(d?.rows) ? d.rows
                           : Array.isArray(d?.data) ? d.data
                           : [];
                setAlerts(rows);
            })
            .catch(err => console.error('Alerts error:', err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="text-gray-400">Loading...</div>;

    return (
        <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Alerts</h2>
            <div className="bg-white rounded-lg shadow-md p-6">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Time</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Severity</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Message</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {alerts.map((alert, idx) => {
                                // alert_history columns: alert_name, severity, message,
                                // notified_via, fired_at, resolved_at. Map onto the
                                // page's older "created_at" / "status" naming.
                                const ts = alert.fired_at || alert.created_at;
                                const status = alert.resolved_at ? 'resolved' : (alert.status || 'open');
                                return (
                                    <tr key={idx} className="hover:bg-gray-50">
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {ts ? new Date(ts).toLocaleString() : '-'}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                                alert.severity === 'critical' ? 'bg-red-100 text-red-800' :
                                                alert.severity === 'warning' ? 'bg-yellow-100 text-yellow-800' :
                                                'bg-blue-100 text-blue-800'
                                            }`}>
                                                {alert.severity}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 text-sm text-gray-900">{alert.message}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{status}</td>
                                    </tr>
                                );
                            })}
                            {alerts.length === 0 && (
                                <tr><td colSpan="4" className="px-6 py-6 text-sm text-gray-400 text-center">No alerts</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
